import "./navbar.scss";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext, useState } from "react";
import newRequest from "../../utils/newRequest";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { I18nextProvider } from "react-i18next";
import LanguageSwitcher from "../../switer";
import i18ns from "../../i18n";
import { useTranslation } from "react-i18next";


const Navbar = () => {
  const navigate = useNavigate();

  const { darkMode } = useContext(DarkModeContext);
  const { dispatch } = useContext(DarkModeContext);
  const { t, i18n } = useTranslation();
  const handleLogout = async () => {
    localStorage.removeItem('currentUser')
    Cookies.remove("accessToken");
    //   try {
    //     const response = await newRequest.post("/logout", {
    //     });
    //     navigate("admin/admin-login");
    //   } catch (error) {
    //     console.log(error);
    //     // navigate("/admin-login");
    //     alert(error?.response?.data?.message || "Something went wrong")
    //   }
    navigate("/admin-login");
  };

  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        alert(
          `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
        );
      });
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };
  return (
    <div className={`navbar text-white flex ${i18n.language === 'ar' ? 'flex-row-reverse' : 'flex-row'}`}
      style={{
        backgroundColor: darkMode ? "#111" : "#323b97",
      }}>
      <div className={`wrapper flex ${i18n.language === 'ar' ? 'flex-row-reverse' : 'flex-row'}`}>
        {/* <div className="search" */}
        {/* // style={{ visibility: 'hidden' }} > */}
        {/* <input type="text" placeholder="Search..."
          /> <SearchOutlinedIcon /> */}
        {/* <button className="userButton" onClick={() => navigate("/assets")}>
          User Section
        </button> */}
        <p className="">
          {/* User Section */}
        </p>
        {/* </div> */}
        <div className={`items flex  ${i18n.language === 'ar' ? 'flex-row-reverse' : 'flex-row'}`}>
          {/* <div className="item text-white">
            <LanguageOutlinedIcon className="icon" />
            English
          </div> */}

          <I18nextProvider i18n={i18ns}>
            <LanguageSwitcher />
          </I18nextProvider>

          <div className="item text-white cursor-pointer">
            <DarkModeOutlinedIcon
              className="icon"
              onClick={() => dispatch({ type: "TOGGLE" })}
            />
          </div>
          <div
            className="item text-white cursor-pointer"
            onClick={toggleFullscreen}
          >
            {isFullscreen ? (
              <FullscreenExitOutlinedIcon className="icon" />
            ) : (
              <FullscreenOutlinedIcon className="icon" />
            )}
          </div>
          <div className="item text-white cursor-pointer">
            <NotificationsNoneOutlinedIcon className="icon" />
            <div className="counter">1</div>
          </div>
          <div className="item text-white cursor-pointer">
            <ChatBubbleOutlineOutlinedIcon className="icon" />
            <div className="counter">2</div>
          </div>
          <div className="item text-white cursor-pointer">
            <ListOutlinedIcon className="icon" />
          </div>
          <div
            className="item text-white cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={handleLogout}
          >
            {/* <img
              src="https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt=""
              className="avatar"
            /> */}
            Logout
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
